import { z } from 'zod';
/** A Firestore document id, or any short slug-like identifier. */
export const IdSchema = z.string().min(1).max(200);
/** ISO 8601 timestamp string. The API always serializes Firestore Timestamps to this shape
 * before they cross into a shared-schema-validated payload. */
export const IsoDateTimeSchema = z.string().datetime({ offset: true });
/** Calendar date only (no time component), e.g. project start/end dates. */
export const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');
/** How many source documents one LLM read (PRD extraction, brainstorm, task import) may attach. */
export const SOURCE_MAX_FILES = 5;
/** Storage paths of source documents already uploaded via one of the .../upload-url routes. */
export const SourcePathsSchema = z.array(z.string().min(1).max(1024)).max(SOURCE_MAX_FILES);
export const EmailSchema = z.string().email();
/** A normalized email domain: lowercased, no leading "@", punycode-encoded by the caller. */
export const DomainSchema = z
    .string()
    .min(3)
    .max(253)
    .regex(/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+$/, {
    message: 'Expected a bare lowercase domain, e.g. example.com',
});
export function normalizeDomain(input) {
    return input.trim().toLowerCase().replace(/^@/, '');
}
export function normalizeEmail(input) {
    return input.trim().toLowerCase();
}
//# sourceMappingURL=common.js.map